export default {
  methods: {
    isLineOrBar(current) {
      return ['bar', 'bar-100', 'bar-simple', 'bar-stacked', 'line-simple', 'area-basic', 'area-stack'].indexOf(current) > -1
    },
    isPie(current) {
      return [
        'pie-doughnut', 'pie-legend', 'pie-nest', 'pie-rose-type', 'funnel'
      ].indexOf(current) > -1
    },
  }
}



// WEBPACK FOOTER //
// app/javascript/components/mixins/charts/type_detector.js